import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import Layout from '~/components/Layout'
import TableComponent from '~/components/TableComponent'
import { RouteTypes } from '~/routes/constants'
import DairyQuery from '~/QueryHooks/DairyQuery'
import { Input } from 'semantic-ui-react'
import { useDebounce } from 'use-lodash-debounce';

const CollectionSites: React.FC = () => {
  const { t } = useTranslation()
  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 20,
    search: ''
  })
  const [search, setSearch] = useState('');

  const debouncedSearchValue = useDebounce(search, 300);

  const {
    isLoading: isBusyCollectionSites,
    data: collectionSitesData,
    isFetching: isFetchingData,
    refetch: fetchCollectionSites
  } = DairyQuery.getCollectionSites({
    ...dataFiltered,
    page: dataFiltered.page === 0 ? dataFiltered.page : dataFiltered.page - 1
  });

  const tableColumnHeaders = [
    {
      name: t('Collection site ID'),
      key: 'uniqueId'
    },
    {
      name: t('EVS-Nr.'),
      key: 'evsNumber'
    },
    {
      name: t('AGIS-ID'),
      key: 'agisId'
    },
    {
      name: t('Name'),
      key: 'name'
    },
    {
      name: t('Abbreviation'),
      key: 'abbreviation'
    },
    {
      name: t('Actions')
    }
  ]

  const actions = [
    {
      popupMessage: t('Edit'),
      type: 'link',
      name: 'pencil',
      size: 'large',
      link: RouteTypes.DAIRY_FACTORY_COLLECTION_SITE_EDIT
    }
  ]

  useEffect(() => {
    if (dataFiltered) {
      fetchCollectionSites();
    }
  }, [dataFiltered]);

  useEffect(() => {
    setDataFiltered({ ...dataFiltered, search: debouncedSearchValue, page: 0 });
  }, [debouncedSearchValue]);

  function renderTable() {
    return <TableComponent
      actions={actions}
      animated
      isFetchingData={isFetchingData}
      tableColumnHeaders={tableColumnHeaders}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      rows={rows}
      total={filtered}
    />
  }

  function renderSearch() {
    return (
      <Input
        icon={{ name: 'search', circular: true, link: true }}
        placeholder={t('Search...')}
        value={search}
        onChange={(e, data) => setSearch(data.value)}
      />
    );
  }

  const { filtered, rows } = collectionSitesData ? collectionSitesData : { filtered: 0, rows: [] };

  return <Layout
    segmented
    title={t('Collection Site')}
    action={RouteTypes.DAIRY_FACTORY_COLLECTION_SITE_CREATE}
    filters={renderSearch()}
    isBusy={isBusyCollectionSites}
  >
    {renderTable()}
  </Layout>
}
export default CollectionSites
